export const ReferralStatus = {
  PENDING: "Pending",
  PARENT_RECEIVED: "Parent Received Referral Packet",
  OMNI_RECEIVED: "Omni Received Referral Packet",
  SIGNED: "Consent for Initial Evaluation Signed",
  SENT_TO_DOE: "Consent for Initial Evaluation Sent to DOE",
};
